<app-user-dashboard>
  <div class="view-container">
    <div class="view-header view-separator pt-0 gap-2">
      <div class="view-container-title w-12">
        <h1 class="view-main-title">{{'AssignStock.AssignProgramTitle' | translate}}</h1>
      </div>
    </div>

    <div class="view-body-container">
      <span class="mt-2 text-sm">{{'AssignStock.AssignProgramDesc' | translate}}</span>
      <div *ngIf="programOrderGuid">
        <app-assign-stock
          #assignStockComponent [isProgramLoad]="true"
          [programOrderGuid]="programOrderGuid"/>
      </div>
    </div>
  </div>
</app-user-dashboard>

